<template>
  <div class="c-member-menu g-content">
    <div class="menu-row">
      <div class="curr-page" @click.stop="toogleMenuStatus">
        <p class="curr-page__name">{{ route.meta.title }}</p>
        <img
          class="curr-page__expand-icon"
          :class="{
            'curr-page__expand-icon--active': menuExpandStatus,
          }"
          src="@/assets/icon/icon_arrow_down_brown.svg"
        />
      </div>

 <!-- v-click-away="(e) => handleMenuStatus(false, e, 'click')" -->
      <n-collapse-transition :show="menuExpandStatus">
        <div class="menu-list-wrap">
          <ul class="menu-list" v-click-away="(e) => handleMenuStatus(false, e)">
            <li
              class="menu-list__item"
              :class="{ 'menu-list__item--active': c.key === menuKey }"
              v-for="c of menuList"
              :key="c.key"
              @click.stop="handleMenu(c.key, c.route)"
            >
              <span class="menu-list__item__text">{{ c.label }}</span>
            </li>
          </ul>
        </div>
      </n-collapse-transition>

      <ul class="menu-list menu-list--pc">
        <li
          class="menu-list__item"
          :class="{ 'menu-list__item--active': c.key === menuKey }"
          v-for="c of menuList"
          :key="c.key"
          @click="handleMenu(c.key, c.route)"
        >
          <span class="menu-list__item__text">{{ c.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, computed, onMounted,
  // watch
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { NCollapseTransition } from 'naive-ui';
import { useSiteStore } from '@/store/site';

export default defineComponent({
  name: 'MemberMenu',
  components: {
    NCollapseTransition,
  },
  emits: ['update:activeKey'],
  setup() {
    const siteStore = useSiteStore();
    const router = useRouter();
    const route = useRoute();
    const menuKey = ref(route.name);
    const menuExpandStatus = ref(false);

    const isAboveTablet = computed(() => siteStore.deviceType.includes('tablet'));

    const toogleMenuStatus = () => {
      menuExpandStatus.value = !menuExpandStatus.value;
    };

    const handleMenuStatus = (status, e) => {
      if (e) {
        e.stopPropagation();
        return;
      }

      if (isAboveTablet.value) {
        menuExpandStatus.value = true;
        return;
      }

      menuExpandStatus.value = status;
    };

    // watch(isAboveTablet, () => {
    //   handleMenuStatus(true, '', 'watch');
    // });

    // 手機版會將網頁狀態列計入高度，會導致一些滑動bug，所以手動設置一個
    function set100VhVar() {
      const vh = window.innerHeight / 100;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    onMounted(() => {
      set100VhVar();
    });

    const menuList = [
      {
        key: 'member-info',
        label: '會員資料變更',
        route: {
          name: 'member-info',
        },
      },
      {
        key: 'baby-info',
        label: '寶寶資訊',
        route: {
          name: 'baby-info',
        },
      },
      {
        key: 'change-password',
        label: '變更密碼',
        route: {
          name: 'change-password',
        },
      },
      {
        key: 'apply',
        label: '我的報名',
        route: {
          name: 'apply',
        },
      },
    ];

    const handleMenu = (key, routeInfo) => {
      menuKey.value = key;
      router.push(routeInfo);
      handleMenuStatus(false);
    };

    return {
      handleMenu,
      menuKey,
      menuList,
      menuExpandStatus,
      handleMenuStatus,
      route,
      toogleMenuStatus,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-member-menu {
  @include flex();
  position: relative;
  top: -25px;
  margin-bottom: 80px;
  border-radius: 10px;
  background-color: $c-white;
  box-shadow: 0px 0px 10px #00000029;
  min-height: 50px;
  max-width: 90%;
  height: auto;
}
.menu-row {
  width: 100%;
  // position: relative;
}

.curr-page {
  position: relative;
  @include flex(center);
  height: 50px;

  &__name {
    @include font-normal($c-main, 16, 700);
  }

  &__expand-icon {
    @include position(tr, 50%, 20px);
    transform: translateY(-50%) rotate(360deg);
    transition: 0.4s;

    &--active {
      transform: translateY(-50%) rotate(180deg);
    }
  }
}

.expand-icon {
  transition: 0.4s;
}

.menu-list-wrap {
  // @include position(tr, 100%, 0);
  width: 100%;
  height: 100%;
  // overflow-y: auto;
}

.menu-list {
  width: 100%;
  @include inline-flex(center, center, column);

  &--pc {
    display: none;
  }

  &__item {
    @include flex(center);
    width: 100%;
    height: 50px;
    background-color: transparent;
    cursor: pointer;
    padding: 0 28px;

    border-radius: 20px;

    &--active {
      color: $c-main;
    }

    &__text {
      @include font-style($c-black, 16, 400, 1.6px, 28px);
    }
  }
}

@media screen and (min-width: $tablet) {
  .menu-list-wrap {
    display: none;
  }

  .c-member-menu {
    @include flex();

    position: relative;
    top: -40px;
    min-height: 80px;
    height: auto;
    padding: 0 133px;
  }

  .curr-page {
    display: none;
  }
  .menu-list {
    @include flex(flex-start);
    height: 80px;

    &--pc {
      @include flex(flex-start);
      @include max-width(1100);
    }

    &__item {
      @include inline-flex();
      width: auto;
      cursor: pointer;
      padding: 0 0px;

      border-radius: 20px;

      & + & {
        margin-left: 75px;
      }

      &--active {
        .menu-list__item__text {
          color: $c-main;
        }
      }
    }
  }
}
</style>
